<template>
    <div class="verify-wrapper">
        <nuxt-link class="back-order" @click.native="goSection()" :to="localePath('/my-account')">
            <div>{{ $t('back') }}</div>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
        </nuxt-link>
        <div class="verify-wrapper2">
            <div class="verify-title">{{ $t('wallet014') }}</div>
            <div class="verify-info">{{ $t('wallet015') }}</div>
            <div class="verify-text">{{ $t('wallet016') }}</div>
            <div class="verify-text2">{{ $t('wallet017') }}</div>

            <div class="verify-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.2299 9.43255C7.2299 6.79812 9.36553 4.6625 12 4.6625C14.6344 4.6625 16.77 6.79812 16.77 9.43255C16.77 12.067 14.6344 14.2026 12 14.2026C12 14.2026 12 14.2026 12 14.2026C9.36553 14.2026 7.2299 12.067 7.2299 9.43255ZM16.1925 15.0032C17.8804 13.7308 18.9716 11.7091 18.9716 9.43255C18.9716 5.58223 15.8503 2.46094 12 2.46094C8.14964 2.46094 5.02834 5.58223 5.02834 9.43255C5.02834 11.7091 6.11954 13.7308 7.80744 15.0032C7.29389 15.2067 6.79411 15.4481 6.31234 15.7261C4.58296 16.7242 3.14669 18.1599 2.14782 19.8888C1.84369 20.4152 2.02389 21.0885 2.5503 21.3926C3.07671 21.6968 3.74998 21.5166 4.05411 20.9902C4.85971 19.5957 6.01808 18.4379 7.41284 17.6329C8.80758 16.8279 10.3896 16.4042 12 16.4042C12 16.4042 12 16.4042 12 16.4042C13.6104 16.4042 15.1925 16.828 16.5872 17.633C17.982 18.438 19.1403 19.5959 19.9459 20.9903C20.25 21.5167 20.9233 21.6969 21.4497 21.3928C21.9761 21.0887 22.1563 20.4154 21.8522 19.889C20.8534 18.1601 19.4171 16.7244 17.6878 15.7262C17.2059 15.4481 16.7061 15.2067 16.1925 15.0032Z" fill="#004F7F"/>
                </svg>
                <div class="text-wrapper">
                    <div class="verify-box-title">{{ $t('wallet018') }}</div>
                    <div class="verify-box-text">{{ $t('wallet019') }}</div>
                </div>
            </div>
            <div class="divider"></div>
            <div class="verify-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20.0843 2.43702C20.0843 1.88068 19.6333 1.42969 19.077 1.42969C18.5207 1.42969 18.0697 1.88068 18.0697 2.43702V4.45091H16.11C15.5536 4.45091 15.1026 4.9019 15.1026 5.45824C15.1026 6.01457 15.5536 6.46557 16.11 6.46557H18.0697V8.45276C18.0697 9.0091 18.5207 9.4601 19.077 9.4601C19.6333 9.4601 20.0843 9.0091 20.0843 8.45276V6.46557H21.9927C22.549 6.46557 23 6.01457 23 5.45824C23 4.9019 22.549 4.45091 21.9927 4.45091H20.0843V2.43702Z" fill="#004F7F"/>
                    <path d="M3.01466 18.5543V6.46636H11.9621C12.5143 6.46636 12.9621 6.01131 12.9621 5.45903C12.9621 4.90674 12.5143 4.45169 11.9621 4.45169H2.88874C1.84562 4.45169 1 5.29731 1 6.34044V18.6802C1 19.7234 1.84562 20.569 2.88874 20.569H21.0207C22.0638 20.569 22.9094 19.7234 22.9094 18.6802V11.3771C22.9094 10.8903 22.5148 10.4957 22.028 10.4957C21.5412 10.4957 21.1466 10.8903 21.1466 11.3771V18.5543H3.01466Z" fill="#004F7F"/>
                    <path d="M12.8361 10.4957C12.4189 10.4957 12.0806 10.834 12.0806 11.2512C12.0806 11.6685 12.4189 12.0067 12.8361 12.0067H19.3838C19.801 12.0067 20.1393 11.6685 20.1393 11.2512C20.1393 10.834 19.801 10.4957 19.3838 10.4957H12.8361Z" fill="#004F7F"/>
                    <path d="M12.8361 13.5177C12.4189 13.5177 12.0806 13.8559 12.0806 14.2732C12.0806 14.6904 12.4189 15.0287 12.8361 15.0287H17.3691C17.7864 15.0287 18.1246 14.6904 18.1246 14.2732C18.1246 13.8559 17.7864 13.5177 17.3691 13.5177H12.8361Z" fill="#004F7F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.49454 12.5967C9.8516 12.1621 10.0659 11.6057 10.0659 10.9993C10.0659 9.60847 8.93844 8.48097 7.54761 8.48097C6.15678 8.48097 5.02928 9.60847 5.02928 10.9993C5.02928 11.6057 5.24363 12.1621 5.60068 12.5967C5.06965 12.9497 4.64011 13.4427 4.36473 14.0224C4.3248 14.1064 4.28808 14.1924 4.25475 14.28C4.10632 14.6701 4.0254 15.0926 4.0254 15.5323H5.53639C5.53639 15.2791 5.58283 15.0385 5.66698 14.8173C5.68593 14.7675 5.70682 14.7186 5.72956 14.6707C6.05318 13.9895 6.74644 13.5211 7.54761 13.5211C8.34878 13.5211 9.04204 13.9895 9.36567 14.6707C9.3884 14.7186 9.40929 14.7675 9.42825 14.8173C9.51239 15.0385 9.55883 15.2791 9.55883 15.5323H11.0698C11.0698 15.0926 10.9889 14.6701 10.8405 14.28C10.8071 14.1924 10.7704 14.1064 10.7305 14.0224C10.4551 13.4427 10.0256 12.9497 9.49454 12.5967ZM8.55494 10.9993C8.55494 11.5556 8.10394 12.0066 7.54761 12.0066C6.99128 12.0066 6.54028 11.5556 6.54028 10.9993C6.54028 10.443 6.99128 9.99197 7.54761 9.99197C8.10394 9.99197 8.55494 10.443 8.55494 10.9993Z" fill="#004F7F"/>
                </svg>
                <div class="text-wrapper">
                    <div class="verify-box-title">{{ $t('wallet020') }}</div>
                    <div class="verify-box-text">{{ $t('wallet021') }}</div>
                </div>
            </div>

            <div class="footer-info">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9286 4.14286C11.3603 4.14286 10.8152 4.36862 10.4133 4.77049C10.0115 5.17235 9.78571 5.71739 9.78571 6.28571V8.42857H14.0714V6.28571C14.0714 5.71739 13.8457 5.17235 13.4438 4.77049C13.0419 4.36862 12.4969 4.14286 11.9286 4.14286ZM7.64286 6.28571V8.42857H4.78571C3.79949 8.42857 3 9.22806 3 10.2143V20.2143C3 21.2005 3.79949 22 4.78571 22H19.0714C20.0577 22 20.8571 21.2005 20.8571 20.2143V10.2143C20.8571 9.22806 20.0577 8.42857 19.0714 8.42857H16.2143V6.28571C16.2143 5.14907 15.7628 4.05898 14.959 3.25526C14.1553 2.45153 13.0652 2 11.9286 2C10.7919 2 9.70184 2.45153 8.89811 3.25526C8.09439 4.05898 7.64286 5.14907 7.64286 6.28571ZM5.14286 10.5714H8.71429H15.1429H18.7143V19.8571H5.14286V10.5714ZM13.3571 15.2143C13.3571 16.0033 12.7176 16.6429 11.9286 16.6429C11.1396 16.6429 10.5 16.0033 10.5 15.2143C10.5 14.4253 11.1396 13.7857 11.9286 13.7857C12.7176 13.7857 13.3571 14.4253 13.3571 15.2143Z" fill="#04010D" fill-opacity="0.6"/>
                </svg>
                <div class="footer-text">{{ $t('wallet022') }}</div>
            </div>

            <nuxt-link :to="localePath('/tell-us-more')" class="continue-btn">{{ $t('continue') }}</nuxt-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "VerifyIdentity",
        head: {
            title: 'Verify Your Identity | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'how-it-works trading-desk inner-page'
            }
        },
        methods: {
            goSection() {
                this.$nuxt.$emit("goToSection", "wallet");
            }
        }
    }
</script>

<style scoped>
.back-order {
    position: absolute;
    right: 0;
    top: 130px;
    font-size: 16px;
    font-weight: 300;
    color: #b2b2b2;
    text-decoration: none;
}

.back-order svg {
    fill: #b2b2b2;
    margin-left: 5px;
}

.back-order:hover {
    color: var(--brand);
    cursor: pointer;
}

.back-order:hover svg {
    fill: var(--brand);
}
.verify-wrapper {
    padding-top: 172px;
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    position: relative;
}
.verify-wrapper2 {
    width: 400px;
    margin: 0 auto;
}
.verify-title {
    color: #04010D;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.verify-info {
    color: rgba(4, 1, 13, 0.60);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 24px;
    margin-bottom: 8px;
}
.verify-text {
    color: #04010D;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 28px;
}
.verify-text2 {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 12px;
    text-transform: uppercase;
}
.verify-box {
    border-radius: 8px;
    background: #F5F5F5;
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 16px;
}
.verify-box-title {
    color: #04010D;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
}
.verify-box-text {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.divider {
    height: 24px;
    width: 1px;
    margin: 16px 28px;
    background: rgba(4, 1, 13, 0.4);
}
.footer-info {
    display: flex;
    padding-top: 80px;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    flex-direction: row;
    margin-bottom: 16px;
}
.footer-text {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.continue-btn {
    display: flex;
    height: 51px;
    padding: 16px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #004F7F;
    margin-bottom: 92px;
    color: white;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    text-decoration: none;
}
</style>

<style>
    .how-it-works .header-toolbar {
        box-shadow: none;
    }
    .inner-page-app .hide-mobile {
        display: none;
    }
</style>
